import PropTypes from 'prop-types';
import React from 'react';

import blueTickSvg from '../../assets/images/blue-tick.svg';
import './ProgressStep.scss';

const ProgressStep = ({
  order,
  label,
  final,
  progress,
  active,
  paths,
  activeGroupIndex,
  currentIndex,
}) => {
  const renderTitle = () => {
    const title = `${order}. ${label}`;

    if (active) {
      return (
        <span className={currentIndex === activeGroupIndex ? 'text-red' : '!text-dark'}>
          {title}
        </span>
      );
    }

    return title;
  };

  const tickedPages = ['eligible'];

  const renderBadge = () => {
    const url = window.location.href;
    const lastSegment = url.split('/').pop();
    if (currentIndex === activeGroupIndex) {
      if (order === 1) {
        if (progress === 0) return <></>;
        if (progress === 1 && paths.length === 1) {
          return <div className="niso-progress-badge desktop-d6">1 of 1</div>;
        }
        if (progress <= paths.length - 1 && lastSegment !== 'ineligible') {
          return (
            <div className="niso-progress-badge desktop-d6">
              {progress} of {paths.length - 1}
            </div>
          );
        }
      } else {
        // the last progress item is where the data gets saved and no user interaction happens,
        // so we don't want to show the progress badge for that.
        if (progress <= paths.length - 2) {
          return (
            <div className="niso-progress-badge desktop-d6">
              {progress + 1} of {paths.length - 1}
            </div>
          );
        }
      }
    }

    if (progress === paths.length - 1 && tickedPages.includes(lastSegment)) {
      return <img src={blueTickSvg} alt="Progress Badge" />;
    }
    if (progress === paths.length) {
      return <img src={blueTickSvg} alt="Progress Badge" />;
    }
  };

  return (
    <div
      className={`progress-step flex items-center justify-between flex-1 ${
        active ? 'is-active' : ''
      }`}
      aria-label={`Section ${order}`}
    >
      <div className={`desktop-d-section-header`}>{renderTitle()}</div>
      {renderBadge()}
    </div>
  );
};

ProgressStep.propTypes = {
  order: PropTypes.number.isRequired,
  label: PropTypes.string.isRequired,
  final: PropTypes.bool.isRequired,
  progress: PropTypes.number,
  active: PropTypes.bool,
  paths: PropTypes.arrayOf(PropTypes.string).isRequired,
  currentIndex: PropTypes.number,
  activeGroupIndex: PropTypes.number,
};

ProgressStep.defaultProps = {
  progress: 0,
  active: false,
};

export default ProgressStep;
